module.exports = __webpack_public_path__ + "static/media/Cruise-ships.067f4325.png";